
export enum AppActionTypes {
    ACTION_SET_LANGUAGE = 'ACTION_SET_LANGUAGE',
  }
  